import React from 'react'
import styled from '@emotion/styled'

import Section from 'Components/Section'
import { Flex } from 'lese'
import CardHeader from 'Components/CardHeader'

export default ({ title, header, cardValues }) => (
  <>
    <Flex xAlign="space-between" separation="16px">
      <Section header={header} title={title} />
      <Flex separation="16px">
        {cardValues.map(val => (
          <CardHeader header={val[0]} title={val[1]}>
            {val[2] || 0}
          </CardHeader>
        ))}
      </Flex>
    </Flex>
  </>
)
